import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors as Colors } from '../../themes/Colors';
import { SVGComponentProps } from '../type';

const EnrollmentStepConnectorIcon: React.FC<SVGComponentProps> = ({
  width = 13,
  height = 66,
  stroke = Colors['light-blue-gray-200'],
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 22L12 12L2 2"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 22V64"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { EnrollmentStepConnectorIcon };
